import React from 'react';
import './App.scss';
import Main from './main';

function App() {
  
  return (
    <div className="App">
      <Main></Main>
    </div>
  );
}

export default App;
